import React, { FC, useCallback, useState } from 'react';
import { SCUIContent } from '../../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralDrawer } from '../../../atomic/molecules';
import { AddUpdateRejectReasonDrawer } from './components/AddUpdateRejectReasonDrawer';
import { Grid } from '@mui/material';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { SCUIButton } from '../../../atomic/atoms';
import CommentRejectReasonDataGrid from './components/CommentRejectReasonDataGrid';
import { PageUrl } from '../../../types/enums';
import { CRR } from './commentRejectReason.classes';

export const CommentRejectReason: FC<any> = () => {
    const { t } = useTranslation();
    const [open, setOpen] = React.useState({
        right: false,
    });
    const onDrawerOpen = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: true }));
    }, []);
    const onDrawerClose = useCallback(() => {
        setOpen((prevOpen) => ({ ...prevOpen, right: false }));
    }, []);
    const [selectedRejectReason, setSelectedRejectReason] = React.useState<any>();
    const [refresh, setRefresh] = useState(false);
    const refreshRejectReason = () => {
        setRefresh((prevLoading) => !prevLoading);
    };
    const handleOpenDrawer = () => {
        setSelectedRejectReason([]);
        onDrawerOpen();
    };
    return (
        <SCUIContent className={CRR.page}>
            <Grid className={CRR.breadcrumbSection} container direction="row" marginTop={'4rem'}>
                <SCUIBreadCrumb
                    title={t('dashboard.commentRejectReasonManagement')}
                    componentLink={PageUrl.commentRejectReason.url}
                    dontShowHome={true}
                    homeIconLink={PageUrl.home.url}
                />
            </Grid>
            <SCUIGeneralDrawer
                open={open['right']}
                anchor="right"
                width={'360px'}
                paperClassName={CRR.drawerPaper}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setOpen({ ...open, right: false });
                    }
                }}
            >
                <div className={CRR.drawerContent}>
                    <AddUpdateRejectReasonDrawer
                        selectedRow={selectedRejectReason}
                        refresh={refreshRejectReason}
                        onClose={onDrawerClose}
                    />
                </div>
            </SCUIGeneralDrawer>
            <Grid
                className={CRR.actionsRow}
                container
                justifyContent="flex-end"
                size={{
                    xs: 12,
                    sm: 12,
                }}
            >
                <SCUIButton
                    className={CRR.addButton}
                    text={t('comments.addRejectReason')}
                    sizeType="fixed"
                    type="primary"
                    size={'l'}
                    onClick={handleOpenDrawer}
                ></SCUIButton>
            </Grid>
            <Grid
                className={CRR.gridSection}
                size={{
                    xs: 12,
                    sm: 12,
                    md: 12,
                    lg: 12,
                }}
            >
                <CommentRejectReasonDataGrid
                    selectedRejectReason={selectedRejectReason}
                    setSelectedRejectReason={setSelectedRejectReason}
                    onDrawerOpen={onDrawerOpen}
                    refresh={refresh}
                />
            </Grid>
        </SCUIContent>
    );
};
